import React, { useState } from "react";
import { Link } from "react-router-dom";
import BusinessAssets from "../components/BusinessAssets";
import PhoneNumberManagement from "../components/PhoneNumberManagement";
import TemplateManagement from "../components/TemplateManagement";

const WhatsAppBusinessPage = () => {
  const [activeTab, setActiveTab] = useState("phones");

  const renderTabContent = () => {
    switch (activeTab) {
      case "phones":
        return <PhoneNumberManagement />;
      case "templates":
        return <TemplateManagement />;
      default:
        return <PhoneNumberManagement />;
    }
  };

  return (
    <div className="min-h-screen bg-blue-50">
      <nav className="bg-white shadow p-4 rounded mb-4 flex justify-between items-center">
        <h2 className="text-2xl font-bold text-blue-600">Settings</h2>
      </nav>
      <div className="max-w-5xl mx-auto">
        <BusinessAssets />
        <div className="mt-6 bg-white rounded shadow">
          <ul className="flex border-b">
            <li
              onClick={() => setActiveTab("phones")}
              className={`cursor-pointer px-6 py-3 ${
                activeTab === "phones"
                  ? "border-b-4 border-blue-600 font-bold text-blue-600"
                  : "text-gray-600 hover:bg-blue-50"
              }`}
            >
              Phone Number Management
            </li>
            <li
              onClick={() => setActiveTab("templates")}
              className={`cursor-pointer px-6 py-3 ${
                activeTab === "templates"
                  ? "border-b-4 border-blue-600 font-bold text-blue-600"
                  : "text-gray-600 hover:bg-blue-50"
              }`}
            >
              Template Management
            </li>
          </ul>
          <div className="p-4">{renderTabContent()}</div>
        </div>
      </div>
    </div>
  );
};

export default WhatsAppBusinessPage;
